import request from '@/utils/request'

let codeApi = {
  /*卡片列表*/
  cardList(data, errorback) {
    return request._post('/shop/plus.cardbook.card/index', data, errorback);
  },
  /*卡片添加*/
  cardAdd(data, errorback) {
    return request._post('/shop/plus.cardbook.card/add', data, errorback);
  },
  /*分类*/
  cardType(data, errorback) {
    return request._post('/shop/plus.cardbook.cate/index', data, errorback);
  },
  /*删除*/
  cardDelete(data, errorback) {
    return request._post('/shop/plus.cardbook.card/delete', data, errorback);
  },
  /*编辑*/
  cardEdit(data, errorback) {
    return request._post('/shop/plus.cardbook.card/edit', data, errorback);
  },
  /*添加分类*/
  cateAdd(data, errorback) {
    return request._post('/shop/plus.cardbook.cate/add', data, errorback);
  },
  /*删除*/
  cateDelete(data, errorback) {
    return request._post('/shop/plus.cardbook.cate/delete', data, errorback);
  },
  /*编辑*/
  cateEdit(data, errorback) {
    return request._post('/shop/plus.cardbook.cate/edit', data, errorback);
  },
  
  
}
export default codeApi;



// WEBPACK FOOTER //
// ./src/api/code.js